import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_project_timesheet,
  get_project_timesheet,
  update_project_timesheet,
} from "../../../../Controllers/Projects/Timesheet";
import forms from "../../../../Data/Forms/Projects/Timesheet/forms";
import headers from "../../../../Data/Forms/Projects/Timesheet/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { convert_to_file } from "../../../../Controllers/Global";
import Projecttimesheetitemstable from "../../../../Data/Forms/Projects/Timesheet/items";
import Projecttimesheetemployeestable from "../../../../Data/Forms/Projects/Timesheet/employees";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import { get_project_task } from "../../../../Controllers/Projects/Tasks";

const ProjectsTimesheetsForm = () => {
  const { project, id } = useParams();
  let navigate = useNavigate();

  headers.navigate.path[0].path = `/app/projects/timesheets/${project}`;

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const [task, setTask] = useState(null);
  const [taskOptions, setTaskOptions] = useState();

  const employeeFocus = useRef([]);

  const [employeeDetails, setEmployeeDetails] = useState([
    // {
    //   id: "",
    //   description: "",
    //   role: "",
    //   hours: "",
    //   charges: "",
    //   worked: "",
    //   total: 0,
    // },
  ]);
  const [employeeTotals, setEmployeeTotals] = useState({
    total: "0.000",
  });

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const timesheet = id
        ? await update_project_timesheet({
            ...data?.data,
            id: id,
            project: project,
            project_task: task,
            employee_details: employeeDetails,
            employee_total: employeeTotals?.total,
          })
        : await create_project_timesheet({
            ...data?.data,
            project: project,
            project_task: task,
            employee_details: employeeDetails,
            employee_total: employeeTotals?.total,
          });

      if (timesheet?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(timesheet?.message);
        setButtonLoader(false);
      } else {
        toast?.error(timesheet?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (timesheet) => {
    let date = timesheet?.date ? timesheet?.date : "";

    values[0].options[0].form.value = date;

    let employee_data = [];
    timesheet?.employee_details?.map((value, index) => {
      employee_data?.push({
        id: value?._id,
        task: value?.task,
        description: value?.description,
        name: value?.name,
        role: value?.role,
        hours: value?.hours,
        charges: value?.charges,
        worked: value?.worked,
        total: value?.total,
      });
    });
    employeeTotals.total = timesheet?.employee_total;

    setTask(timesheet?.project_task?._id);
    setTaskOptions([
      {
        value: timesheet?.project_task?._id,
        label: timesheet?.project_task?.name,
      },
    ]);
    setEmployeeDetails([...employee_data]);
    setEmployeeTotals({ ...employeeTotals });
    setValues([...values]);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const timesheet = await get_project_timesheet(data);
      if (timesheet?.status) {
        handleData(timesheet?.data);
      } else {
        toast?.error(timesheet?.message);
      }
    } else {
      setLoader(false);
    }
  };

  const getformdata = async (formdata) => {};

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          getformdata={getformdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={3} title={"Employees"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Projecttimesheetemployeestable
                task={task}
                setTask={setTask}
                project={project}
                taskOptions={taskOptions}
                setTaskOptions={setTaskOptions}
                employeeDetails={employeeDetails}
                setEmployeeDetails={setEmployeeDetails}
                employeeTotals={employeeTotals}
                setEmployeeTotals={setEmployeeTotals}
                ref={employeeFocus}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default ProjectsTimesheetsForm;
